var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component"},[_vm._v(" "+_vm._s(_vm.beforeEndingWordGroup)+" "),_c('span',{staticClass:"word-group"},[_vm._v(_vm._s(_vm.endingWordGroup))])])
}
var staticRenderFns = []

export { render, staticRenderFns }